import api from '../services/api';
import { parsePayloadsDateRange } from '../utils/helper';

export default {
  get: async ({
    start_date, end_date, device_id, page = 1, token,
  }) => {
    let payloads = [];
    let payloadMeta = {};

    const resetPayloads = () => {
      payloads = [];
      payloadMeta = {};
    };

    if (page === 1) {
      resetPayloads();
    }

    const getData = async () => {
      try {
        const response = await api.getUplinkPayloads({
          device_id,
          start_date,
          end_date,
          page,
          load_payloads: 1,
        }, token);

        const { data, meta } = response.data;
        if (data.length !== 0) {
          const parsedPayloads = parsePayloadsDateRange(data);
          payloads = [...payloads, ...parsedPayloads];
          payloadMeta = meta;
          return;
        }
        if (page === 1) {
          resetPayloads();
        }
      } catch (error) {
        console.error(`Failed get payloads. ${error}`);
      }
    };

    await getData();

    return {
      getData,
      payloads,
      payloadMeta,
    };
  },
};
